import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Gear to /setup — the kiosk's only way to staff settings, on whichever screen
 * is the device's resting state: the chooser, the scan screen, or the find
 * screen in type mode (D-019). Moved here verbatim from ScanScreen.
 *
 * Small and quiet on purpose — it is a staff control sitting in a public lobby.
 * A long press works too, for tablets where the tap target is awkward with a
 * case on.
 */
export default function GearLink() {
  const navigate = useNavigate();
  const timerRef = useRef(0);

  const start = () => {
    timerRef.current = window.setTimeout(() => navigate("/setup"), 700);
  };
  const cancel = () => {
    if (timerRef.current) window.clearTimeout(timerRef.current);
    timerRef.current = 0;
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, []);

  return (
    <button
      type="button"
      className="gear"
      aria-label="Device setup"
      onClick={() => navigate("/setup")}
      onPointerDown={start}
      onPointerUp={cancel}
      onPointerLeave={cancel}
      onContextMenu={(event) => event.preventDefault()}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="3.2" stroke="currentColor" strokeWidth="1.8" />
        <path
          d="M12 2.6v2.2M12 19.2v2.2M21.4 12h-2.2M4.8 12H2.6M18.6 5.4l-1.6 1.6M7 17l-1.6 1.6M18.6 18.6L17 17M7 7 5.4 5.4"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
}
